"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrazeProvider = exports.BrazeContext = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const BrazeContext = exports.BrazeContext = /*#__PURE__*/(0, _react.createContext)({
  initialize: () => {},
  loginCustomer: () => {},
  createPurchase: () => {}
});
const BrazeProvider = ({
  children,
  sdkKey,
  brazeUrl
}) => {
  const invalidConfig = !sdkKey || !brazeUrl;

  /**
   * Initialize Braze SDK
   *
   * @param enableLogging string
   */
  const initialize = enableLogging => {
    if (invalidConfig) return;
    try {
      Promise.resolve().then(() => _interopRequireWildcard(require( /* webpackExports: ['initialize', 'openSession'] */
      '@braze/web-sdk'))).then(({
        initialize,
        openSession
      }) => {
        initialize(sdkKey, {
          baseUrl: brazeUrl,
          enableLogging: enableLogging,
          doNotLoadFontAwesome: true
        });
        openSession();
      });
    } catch (error) {}
  };

  /**
   * Login the customer to Braze
   * If customer is already logged in, it does nothing
   *
   * @param userId string
   */
  const loginCustomer = userId => {
    if (invalidConfig) return;
    try {
      Promise.resolve().then(() => _interopRequireWildcard(require( /* webpackExports: ['changeUser'] */
      '@braze/web-sdk'))).then(({
        changeUser
      }) => {
        changeUser(userId);
      });
    } catch (error) {}
  };

  /**
   * Create purchase lines for Braze event
   *
   * @param order Order
   */
  const createPurchasesObject = order => {
    return order.productItems.map(product => {
      var _product$priceAdjustm;
      const promoIds = ((_product$priceAdjustm = product.priceAdjustments) === null || _product$priceAdjustm === void 0 ? void 0 : _product$priceAdjustm.map(priceAdjustment => {
        return priceAdjustment.promotionId;
      })) || [];
      return {
        product_id: product.productName,
        currency: 'USD',
        price: product.basePrice,
        quantity: product.quantity,
        properties: {
          sku: product.productId,
          class_category: product.c_classCategory,
          promo_ids: promoIds
        }
      };
    });
  };

  /**
   * Create purchase event in Braze
   *
   * @param order Order
   */
  const createPurchase = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)(function* (order) {
      if (invalidConfig) return;
      const purchases = createPurchasesObject(order);
      try {
        Promise.resolve().then(() => _interopRequireWildcard(require( /* webpackExports: ['logPurchase'] */
        '@braze/web-sdk'))).then(({
          logPurchase
        }) => {
          purchases.forEach(purchase => {
            logPurchase(purchase.product_id, purchase.price, purchase.currency, purchase.quantity, purchase.properties);
          });
        });
      } catch (error) {}
    });
    return function createPurchase(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react.default.createElement(BrazeContext.Provider, {
    value: {
      initialize,
      loginCustomer,
      createPurchase
    }
  }, children);
};
exports.BrazeProvider = BrazeProvider;